// src/token.ts
import { token as pandaToken } from "../styled-system/tokens/index.js";
var token = Object.assign(pandaToken, {
  computed(path, fallback) {
    if (typeof window === "undefined") {
      if (fallback == null) {
        throw new Error(
          "Cannot compute token value on SSR. Use a default value to avoid this error."
        );
      }
      return fallback;
    }
    if (path.startsWith("spacing") || path.startsWith("radii") || path.startsWith("borderWidths") || path.startsWith("sizes")) {
      const value = pandaToken(path, fallback?.toString());
      const remValue = parseFloat(value);
      const rootFontize = parseFloat(
        getComputedStyle(document.documentElement).fontSize || "16px"
      );
      return remValue * rootFontize;
    }
    if (path.startsWith("colors")) {
      const value = pandaToken.var(path, fallback?.toString()).replace("var(", "").replace(")", "");
      return getComputedStyle(document.documentElement).getPropertyValue(
        value
      );
    }
    throw new Error(`Cannot compute token value for "${path}"`);
  }
});

// src/css.ts
import { css as pandaCssFn } from "../styled-system/css/index.js";
function flattenCssProp(cssProp) {
  if (!cssProp) {
    return [];
  }
  if (Array.isArray(cssProp)) {
    return cssProp.flatMap(flattenCssProp);
  }
  return [cssProp];
}
var css = Object.assign(
  function css2(...args) {
    const flattened = flattenCssProp(args);
    return pandaCssFn(...flattened);
  },
  {
    raw: function raw(...args) {
      const flattened = flattenCssProp(args);
      return pandaCssFn.raw(...flattened);
    }
  }
);

// src/main.ts
import { cx, cva, sva } from "../styled-system/css/index.js";
export {
  css,
  cva,
  cx,
  sva,
  token
};
//# sourceMappingURL=index.js.map